const gTagMetadata = {
  unstract: {
    event: "hubspot-unstract-signup",
    hsFormGuid: "0474476f-435f-45fc-bf57-203a08e078ad",
  },
  "llm-whisperer": {
    event: "hubspot-llmwhisperer-signup",
    hsFormGuid: "69d59c2d-46d5-4764-b83a-1eb20e6dddcc",
  },
};

const useGoogleTagManager = () => {
  return (type) => {
    window.dataLayer.push({
      event: gTagMetadata?.[type]?.event,
      "hs-form-guid": gTagMetadata?.[type]?.hsFormGuid,
    });
  };
};

export { useGoogleTagManager };
